import { useMemo } from 'react';
import { useKeywords } from '@app/hooks';
import { FlatExperience } from '@app/utils/types';

function useFlatExperiences({ eventData, flatExperiencesData }: any) {
  let foundFlatExperiencesData: any;

  if (eventData) {
    foundFlatExperiencesData = eventData?.homePage?.find(
      (el: any) => el.__typename === 'ComponentFlexpsFlExpGr'
    );
  } else {
    foundFlatExperiencesData = flatExperiencesData;
  }

  const keywords = useKeywords(
    foundFlatExperiencesData?.flat_experience_groups?.[0]?.keywords || []
  );

  const { flatExperiencesContent, groupId, flatExperiencesCarouselTitle } =
    useMemo(() => {
      return {
        flatExperiencesContent: (foundFlatExperiencesData
          ?.flat_experience_groups?.[0]?.flat_experiences ||
          []) as FlatExperience[],
        groupId: foundFlatExperiencesData?.flat_experience_groups?.[0]?.slug,
        flatExperiencesCarouselTitle:
          foundFlatExperiencesData?.flat_experience_groups?.[0]
            ?.homeCarouselTitle,
      };
    }, [foundFlatExperiencesData]);

  return {
    flatExperiencesContent,
    groupId,
    keywords,
    flatExperiencesCarouselTitle,
  };
}

export default useFlatExperiences;
